module.exports = "../static/images/45cad8.gif";